import React from "react"
import { Fragment } from "react"
import { Alert } from "react-bootstrap"
import { TextField } from "@mui/material"

import Constants from "../../config.js"
import { getLog } from "../../helpers/helpers.js"
import { decryptMnemonic, isArgon2Blob } from "../../helpers/wallet_crypto"
import { SlidePopup } from "../WithPopup/TextCopyQR.js"
import { ButtonPrimary, ButtonPrimaryOutlined, ButtonSecondary } from "../../components/Buttons.js"

import "./upload_download_file.css"

const CryptoJS = require("crypto-js")

// TODO add to storybook

// Buttons upload + download


/**
 * 
 * @param {*} props
 * 			- loading_info_jsx - jsx
 *   		- password_onchange - function
 * 			- handleOnConfirmPassword - function
 * 			- reset_inputs - function
 * 			- psw_loading - boolean
 * 			- walletname - string
 * 			- password string
 *			- (optional) onClickContinue			callback
 * @returns 
 */
const PasswordInput = (props) => {
	const function_id = "PasswordInput(): "
	const log = getLog(function_id)

	// functions
	const password_onchange = props.password_onchange,
		handleOnConfirmPassword = props.handleOnConfirmPassword,
		reset_inputs = props.reset_inputs

	var title = "Entrez le mot de passe:"
	if (props.walletname) {
		title = "Entrez le mot de passe pour le portefeuille: " + props.walletname
	}

	const handleOnKeyDown = (e) => {
		if (e.key == "Enter") {
			handleOnConfirmPassword()
		}
	}

	log("props.psw_loading=", props.psw_loading,
		"\n props.loading_info_jsx=", props.loading_info_jsx)

	var popupcontent = (
		<div style={{ marginTop: "25vh", maxWidth: "800px", margin: "25vh auto 0 auto" }}>

			<div>{title}</div>
			<br />

			<span style={{ position: "relative" }}>
				{/* <input
					type="password"
					onChange={password_onchange}
					onKeyDown={handleOnKeyDown}
					value={props.password}
					id="psw"
					name="psw"
					required
					style={{ width: "15em" }}
				/>
				<br />
				<button
					id="password_go"
					onClick={handleOnConfirmPassword}
					style={{
						fontSize: "16px",
						padding: "0px 10px",
						right: "0%",
						top: "0%",
						outline: "none",
						position: "absolute",
						cursor: "pointer",
						backgroundColor: "Transparent",
						border: "none",
						color: "grey",
					}}
				>
				*/}
				<TextField fullWidth
					id="outlined-basic"
					variant="outlined"
					type="password"
					onChange={password_onchange}
					onKeyDown={handleOnKeyDown}
					value={props.password}
					label={<span>mot de passe du fichier</span>}
					style={{ width: "350px" }}
				// placeholder="mot de passe"
				// helperText={Constants.SEND_TOKENS_POPOVER}
				/>
				{/* button with right-arrow */}
				<button
					id="password_go"
					onClick={handleOnConfirmPassword}
					style={{
						fontSize: "16px",
						top: "calc(100% - 8px)",
						padding: "0px 10px",
						right: "8px",
						outline: "none",
						position: "absolute",
						cursor: "pointer",
						backgroundColor: "Transparent",
						border: "none",
						color: "grey",
					}}
				>
					<i id="button-icon" className="fas fa-arrow-circle-right" />
				</button>
			</span>
			<br />

			{props.psw_loading ? props.loading_info_jsx : null}
			<br />

			{/* Remember this wallet on this device (opt-in localStorage) */}
			<Alert variant="secondary" style={{ fontSize: "16px", textAlign: "left", margin: "10px 0" }}>
				<label style={{ cursor: "pointer", display: "flex", alignItems: "flex-start", gap: "8px" }}>
					<input
						type="checkbox"
						checked={props.rememberDevice || false}
						onChange={props.onChange_rememberDevice}
						style={{ marginTop: "4px", transform: "scale(1.3)" }}
					/>
					<span>
						<b>{Constants.REMEMBER_DEVICE_QUESTION}</b><br />
						<span style={{ fontSize: "14px" }}>{Constants.REMEMBER_DEVICE_INFO}</span>
					</span>
				</label>
			</Alert>
			<br />

			<ButtonPrimaryOutlined
				onClick={reset_inputs}
				disabled={props.psw_loading}
				style={{ backgroundColor: props.psw_loading ? "grey" : null }}
			>
				Fermer
			</ButtonPrimaryOutlined>

			<ButtonPrimary
				onClick={handleOnConfirmPassword}
				disabled={props.psw_loading}
				style={{ marginLeft: "20px", backgroundColor: props.psw_loading ? "grey" : null }}
			>
				OK
			</ButtonPrimary>
		</div>
	)

	return (
		<SlidePopup fullWidth hideButton="true">
			{popupcontent}
		</SlidePopup>
	)
}

/**
	props:
		- getDecryptedContent : callback function to deal with the content
		- (optional) forceFileContent :     json, force a file content instead of waiting for user to open a file
		- (optional) loading_info_jsx       add some jsx for added information on loading
		- (optional) onCloseButtonClicked   callback

	ex usage: <UploadButton getDecryptedContent={this.onGetContent}/>
**/
export class UploadButton extends React.Component {
	constructor(props) {
		super(props)

		this.classname = "UploadButton: "

		this.state = {
			fileisvalid: false,
			showpopup: false,
			infomess: Constants.INVALID_FILE,
			password: "",
			psw_valid: false,
			psw_loading: false,
			jsoncontent: null,
			rememberDevice: false,  // opt-in: store encrypted blob in localStorage
		}
		this.initialState = this.state

		this.myRef = React.createRef()
		this.errMessRef = React.createRef()

		this.handleFileRead = this.handleFileRead.bind(this)
		this.handleFileChosen = this.handleFileChosen.bind(this)
		this.buttonclick = this.buttonclick.bind(this)
		this.password_validate = this.password_validate.bind(this)
		this.password_onchange = this.password_onchange.bind(this)
		this.handleChange_rememberDevice = this.handleChange_rememberDevice.bind(this)
		this.reset_inputs = this.reset_inputs.bind(this)
		this.handleOnConfirmPassword = this.handleOnConfirmPassword.bind(this)

		this.fileReader = null
		this.loadedfilepath = ""
		this.filecontent = ""
		this.walletname = ""
	}


	componentDidMount() {
		if (this.props.forceFileContent) {
			this.filecontent = JSON.parse(this.props.forceFileContent)
			this.setState({
				fileisvalid: true,
				showpopup: true,
			})
		}
	}


	async password_validate() {
		const function_id = this.classname + "password_validate(): "
		const log = getLog(function_id)

		log("this.filecontent=", this.filecontent)

		var jsoncontent = this.filecontent
		if (typeof jsoncontent == "string") jsoncontent = JSON.parse(jsoncontent)  // safety check

		// DECRYPT mnemonic WITH PASSWORD
		var encrypted_mnemonic = jsoncontent.encrypted_mnemonic

		// decrypt — branch on the crypto-format discriminator.
		// Old files (no `kdf` field) fall through to the legacy CryptoJS path.
		var success = false
		var originalText = null
		if (isArgon2Blob(jsoncontent)) {
			try {
				originalText = await decryptMnemonic(jsoncontent, this.state.password)
				if (originalText && originalText.length > 0) success = true
			} catch (err) {
				log("argon2id decrypt threw:", err)
			}
		} else {
			try {
				var bytes = CryptoJS.AES.decrypt(encrypted_mnemonic, this.state.password)
				originalText = bytes.toString(CryptoJS.enc.Utf8)
				if (originalText.length > 0) success = true
			} catch (err) {
				// don't use alert in production in electron !!! it will freeze everything
				// alert(err)
			}
		}
		log("success=", success)

		if (!success) {
			// if in production mode
			log("!!window.electron=", !!window.electron)
			if (window.electron) {
				window.electron.openDialogShowErrorBox("Echec", "échec, mauvais mot de passe.")
			} else {
				// don't use alert in production !!! it will freeze everything
				alert("échec, mauvais mot de passe.")
			}
			this.reset_inputs(false)
		} else {
			jsoncontent.mnemonic = originalText
			this.setState({
				psw_valid: true,
				jsoncontent: jsoncontent,
			})
			log("setState({psw_valid: true}) done")
		}
	}


	password_onchange(event) {
		event.preventDefault()  // prevent redirection
		this.setState({ password: event.target.value })
	}


	handleChange_rememberDevice(event) {
		this.setState({ rememberDevice: event.target.checked })
	}


	reset_inputs(with_close_popup = true) {
		const function_id = this.classname + "reset_inputs(): "
		const log = getLog(function_id)
		log("called")

		if (this.myRef.current) this.myRef.current.value = ""  // reset input

		if (with_close_popup) {
			// close button has been clicked
			this.setState({ ...this.initialState, showpopup: false })
			if (this.props.onCloseButtonClicked) this.props.onCloseButtonClicked()
		}
		else {
			// reset state but without closing popup
			this.setState({
				...this.initialState,
				showpopup: true,
				fileisvalid: true,  // also necessary to not close popup
			})
		}

		log("ended")
	}


	handleOnConfirmPassword(e) {
		const log = getLog("handleOnConfirmPassword():")

		this.setState({
			psw_loading: true,
		})

		// setTimeout because react needs time to update the UI
		setTimeout(() => {
			this.password_validate()
		}, 1200)

	}


	handleFileRead(e) {
		const function_id = this.classname + "handleFileRead(): "
		const log = getLog(function_id)

		const content = this.fileReader.result
		// log("File content :", content)  // TODO remove that it can contain privkeys!

		var walletname = JSON.parse(content).walletname
		if (walletname) {
			this.walletname = walletname
		}

		// check what you want for your file to be valid
		var validfile = true  // TODO coder une vraie analyse du contenu
		if (validfile) {
			// show popup to enter password
			this.setState({ fileisvalid: true, showpopup: true })
			// this.errMessRef.current.style.display = "none"
			this.errMessRef.current.style.display = "block"
		} else {
			this.setState({ fileisvalid: false, showpopup: false })
			this.errMessRef.current.style.display = "block"
			this.forceUpdate() //force render
			return null
		}
		// file is valid, do something with the 'content'

		// chemin
		this.loadedfilepath = this.myRef.current.value
		log("file :", this.loadedfilepath)

		// taille
		var nBytes = 0
		nBytes = this.loadedfilepath.length
		log("file length in bytes :", nBytes)

		this.filecontent = content

		this.forceUpdate()  // force render
	}


	handleFileChosen(file) {
		const function_id = this.classname + "handleFileChosen(): "
		const log = getLog(function_id)

		log("file = ", file)
		this.fileReader = new window.FileReader()
		if (this.fileReader) {
			this.fileReader.onloadend = this.handleFileRead
			this.fileReader.readAsText(file)
		} else {
			this.reset_inputs()
		}
	}


	buttonclick() {
		this.myRef.current.click()
	}


	render() {
		const function_id = this.classname + "render(): "
		const log = getLog(function_id)

		// just load the file: onChange={e => this.handleFileChosen(e.target.files[0])}
		// show informations : onChange={this.onChangeHandler}
		// add "multiple" to the input to load  multiple files

		log("this.state.psw_valid =", this.state.psw_valid)

		log("this.props =", this.props)

		var showpopup = ""
		if (this.state.fileisvalid && this.state.showpopup) {
			showpopup = <PasswordInput
				loading_info_jsx={this.props.loading_info_jsx}
				password_onchange={this.password_onchange}
				handleOnConfirmPassword={this.handleOnConfirmPassword}
				reset_inputs={this.reset_inputs}
				psw_loading={this.state.psw_loading}
				walletname={this.state.walletname}
				password={this.state.password}
				rememberDevice={this.state.rememberDevice}
				onChange_rememberDevice={this.handleChange_rememberDevice}
			/>
		}

		if (this.state.psw_valid) {
			// need small await to update rendering before continuing
			setTimeout(() => {
				log("calling props.getDecryptedContent()")
				// remonte la valeur au composant parent
				// we also pass the password + rememberDevice so the parent can
				// call setWalletPassword() to save an encrypted session blob
				// for stay-logged-in-across-refresh
				this.props.getDecryptedContent(this.state.jsoncontent, this.state.password, this.state.rememberDevice)
			}, 800)
		}

		// in case of forceFileContent we don't display any button just the popup for password
		if (this.props.forceFileContent) {
			return <Fragment>{showpopup}</Fragment>
		} else {
			return (
				<Fragment>
					{showpopup}
					<div>
						<input
							ref={this.myRef}
							style={{ display: "none" }}
							type="file"
							accept=".tokkenr, .delphe"
							onChange={(e) => this.handleFileChosen(e.target.files[0])}
						/>

						<ButtonSecondary
							className="upload-download-button"
							onClick={this.buttonclick}
							style={{ borderRadius: "10em", padding: "10px 20px" }}
						>
							<i className="fas fa-upload" id="button-icon"></i>&nbsp;
							Upload File
						</ButtonSecondary>
					</div>
					<div>
						<span ref={this.errMessRef}
							style={{ padding: "10px", display: "none" }}
						>
							{this.state.infomess}
						</span>
					</div>
				</Fragment>
			)
		}
	}
}



/** props:
		- text: contenu du fichier
		- name: nom du fichier
*/
export class DownloadButton extends React.Component {
	render() {
		var file = new Blob([this.props.text], { type: "text/plain" })
		return (
			<Fragment>
				<span>
					<a href={URL.createObjectURL(file)} download={this.props.name}>
						<button className="upload-download-button">
							Télécharger
						</button>
					</a>
				</span>
				<br />
			</Fragment>
		)
	}
}
